import React from "react";
import {NavLink} from "react-router-dom";
import {useLocaleContext} from "../../../context/LocaleContext";
import "./style.scss";

export default ({pages, onClose, watchKey}) => {
    const {getProperty} = useLocaleContext();
    const className = 'modal-menu-mobile';

    return (
        <nav className={className}>
            {pages?.map((page) => (
                <div key={page.path}>
                    <NavLink to={`/event/${watchKey}/${page.path}`} onClick={onClose}>
                        {getProperty(page, 'title')}
                    </NavLink>
                </div>
            ))}
        </nav>
    );
}
